import { axiosInstance } from "../axios";
import { custom_domain_apis } from "../ApiConst";
import { AxiosResponse } from "axios";
import {
    CustomDomainResponse,
    CustomDomainListData,
    CustomDomainDetailData,
    CreateCustomDomainPayload,
    ResolveCustomDomainResponse,
    ResolveCustomDomainData,
} from "../../Components/CustomDomains/types";

export const GetCustomDomainList = async (): Promise<
    AxiosResponse<CustomDomainResponse<CustomDomainListData[]>>
> => {
    return await axiosInstance.get<
        CustomDomainResponse<CustomDomainListData[]>
    >(custom_domain_apis.list, {
        // @ts-ignore
        useUserToken: true,
    });
};
export const GetCustomDomainDetail = async (
    id: number,
): Promise<AxiosResponse<CustomDomainResponse<CustomDomainDetailData>>> => {
    return await axiosInstance.get<CustomDomainResponse<CustomDomainDetailData>>(
        custom_domain_apis.detail(id),
        {
            // @ts-ignore
            useUserToken: true,
        },
    );
};

export const CreateCustomDomain = async (
    payload: CreateCustomDomainPayload,
): Promise<AxiosResponse<CustomDomainResponse<CustomDomainListData>>> => {
    return await axiosInstance.post<CustomDomainResponse<CustomDomainListData>>(
        custom_domain_apis.create,
        payload,
        {
            // @ts-ignore
            useUserToken: true,
        },
    );
};

export const VerifyCustomDomain = async (
    domainId: number,
): Promise<AxiosResponse<CustomDomainResponse<CustomDomainListData>>> => {
    return await axiosInstance.post<CustomDomainResponse<CustomDomainListData>>(
        custom_domain_apis.verify(domainId),
        {},
        {
            // @ts-ignore
            useUserToken: true,
        },
    );
};

export const RetryCustomDomain = async (
    domainId: number,
): Promise<AxiosResponse<CustomDomainResponse<CustomDomainListData>>> => {
    return await axiosInstance.post<CustomDomainResponse<CustomDomainListData>>(
        custom_domain_apis.retry(domainId),
        {},
        {
            // @ts-ignore
            useUserToken: true,
        },
    );
};

export const DeleteCustomDomain = async (
    domainId: number,
): Promise<AxiosResponse<CustomDomainResponse<CustomDomainListData>>> => {
    return await axiosInstance.delete<CustomDomainResponse<CustomDomainListData>>(
        custom_domain_apis.delete(domainId),
        {
            // @ts-ignore
            useUserToken: true,
        },
    );
};

export const ResolveCustomDomain = async (hostname: string) => {
    return await axiosInstance.get<ResolveCustomDomainResponse<ResolveCustomDomainData>>(
        custom_domain_apis.resolve,
        {
            // @ts-ignore
            useUserToken: false,
            params: {
                hostname,
            },
        },
    );
};